//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { aiStatisticsUserDetailApi, aiStatisticsActionListApi } from '@/api/aiStatistics';
export default {
  name: 'UserDetailDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String],
      default: null
    },
    userName: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      user: {},
      trend: [],
      actionLoading: false,
      actions: [],
      actionTotal: 0,
      actionFrom: {
        actionType: '',
        page: 1,
        limit: 10
      }
    };
  },
  methods: {
    handleOpen: function handleOpen() {
      this.user = {};
      this.trend = [];
      this.actions = [];
      this.actionTotal = 0;
      this.actionFrom.page = 1;
      this.actionFrom.actionType = '';
      this.loadDetail();
      this.loadActions();
    },
    loadDetail: function loadDetail() {
      var _this = this;
      if (!this.uid) return;
      this.loading = true;
      aiStatisticsUserDetailApi({
        uid: this.uid,
        startTime: this.startTime,
        endTime: this.endTime
      }).then(function (res) {
        _this.user = res && res.user || {};
        _this.trend = res && res.trend || [];
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    loadActions: function loadActions() {
      var _this2 = this;
      if (!this.uid) return;
      this.actionLoading = true;
      aiStatisticsActionListApi({
        uid: this.uid,
        actionType: this.actionFrom.actionType,
        startTime: this.startTime,
        endTime: this.endTime,
        page: this.actionFrom.page,
        limit: this.actionFrom.limit
      }).then(function (res) {
        _this2.actions = res && res.list || [];
        _this2.actionTotal = res && res.total || 0;
        _this2.actionLoading = false;
      }).catch(function () {
        _this2.actionLoading = false;
      });
    },
    handleActionTypeChange: function handleActionTypeChange() {
      this.actionFrom.page = 1;
      this.loadActions();
    },
    handleActionPageChange: function handleActionPageChange(page) {
      this.actionFrom.page = page;
      this.loadActions();
    },
    actionTypeText: function actionTypeText(type) {
      var map = {
        activity_create: '创建活动',
        market_create: '创建集市',
        activity_apply: '活动报名',
        activity_update: '编辑活动',
        market_update: '编辑集市',
        activity_publish: '活动上架',
        market_publish: '集市上架'
      };
      return map[type] || type;
    },
    actionTagType: function actionTagType(type) {
      var map = {
        activity_create: 'success',
        market_create: 'warning',
        activity_apply: ''
      };
      return map[type] || 'info';
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';
      var num = Number(value);
      if (isNaN(num)) return String(value);
      return num.toLocaleString('zh-CN');
    }
  }
};